import { Link } from "react-router-dom";
import { PhoneIcon, MailIcon } from "./ContactIcons";

// Shared between the marketing page (/book/:slug) and the reader
// (/read/:slug) so both end on the same "Get In Touch" + footer.
export default function BookFooter({ book }) {
  const hasContact = Boolean(book.contact_phone || book.contact_email);

  return (
    <>
      {hasContact && (
        <section className="bg-black px-6 py-16 text-center">
          <h3 className="font-heading text-2xl font-extrabold text-white">
            Get In Touch
          </h3>
          <div className="mx-auto mt-8 flex max-w-2xl flex-wrap justify-center gap-4">
            {book.contact_phone && (
              <a
                href={`tel:${book.contact_phone.replace(/[^\d+]/g, "")}`}
                className="flex items-center gap-3 rounded-2xl border border-white/10 bg-zinc-900 px-6 py-4 font-semibold text-zinc-100 shadow-[0_2px_12px_rgba(0,0,0,0.4)] transition-all duration-300 hover:-translate-y-0.5 hover:border-white/20"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                  <PhoneIcon />
                </span>
                {book.contact_phone}
              </a>
            )}
            {book.contact_email && (
              <a
                href={`mailto:${book.contact_email}`}
                className="flex items-center gap-3 rounded-2xl border border-white/10 bg-zinc-900 px-6 py-4 font-semibold text-zinc-100 shadow-[0_2px_12px_rgba(0,0,0,0.4)] transition-all duration-300 hover:-translate-y-0.5 hover:border-white/20"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                  <MailIcon />
                </span>
                {book.contact_email}
              </a>
            )}
          </div>
        </section>
      )}

      <footer className="border-t border-white/10 bg-black px-6 py-10 text-center text-sm text-zinc-400">
        <p>
          {book.author_name.toUpperCase()} © {new Date(book.created_at).getFullYear()} — All Rights Reserved
        </p>
        <Link to="/privacy-policy" className="mt-1 inline-block underline hover:text-zinc-200">
          Privacy Policy
        </Link>
      </footer>
    </>
  );
}
